import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Col, Row } from 'reactstrap';
import Flatpickr from "react-flatpickr";
import { useProfile } from "../../../Components/Hooks/UserHooks";
import {setAuthorization} from "../../../helpers/api_helper";

const Section = (props) => {
    return (
        <React.Fragment>
            <Row className="mb-3 pb-1">
                <Col xs={12}>
                    <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                        <div className="flex-grow-1">
                            <h4 className="fs-16 mb-1">Report for the <b>{props.ProjectName}</b> project</h4>
                            {/* <p className="text-muted mb-0">This is the total situation with the buildings</p> */}
                        </div>
                        <div className="mt-3 mt-lg-0">
                            <form action="#">
                            </form>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default Section;
